import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { groups as groupsApi } from '@afosto/catalog/api/Groups';
import SkeletonBody from '@afosto/components-react/SkeletonBody';

const PriceGroupFormatter = ({ pricingGroupID }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [priceGroup, setPriceGroup] = useState(null);

  useEffect(() => {
    let isMounted = true;

    const fetchPriceGroup = async id => {
      setIsLoading(true);

      try {
        const response = await groupsApi.viewGroup(id);
        const { data = null } = response;

        if (isMounted) {
          setPriceGroup(data);
        }
      } catch (err) {
        if (isMounted) {
          setPriceGroup(null);
        }
      } finally {
        if (isMounted) {
          setIsLoading(false);
        }
      }
    };

    if (pricingGroupID && pricingGroupID !== '') {
      fetchPriceGroup(pricingGroupID);
    }

    return () => {
      isMounted = false;
    };
  }, [pricingGroupID]);

  if (isLoading) {
    return <SkeletonBody lines={1} />;
  }

  return priceGroup?.name ?? null;
};

PriceGroupFormatter.propTypes = {
  pricingGroupID: PropTypes.string,
};

PriceGroupFormatter.defaultProps = {
  pricingGroupID: undefined,
};

export default PriceGroupFormatter;
